import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "uploaded-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.1973 12.5674C15.4902 12.2746 15.4903 11.7997 15.1974 11.5068C14.9046 11.2138 14.4297 11.2138 14.1368 11.5066L11.3331 14.3094L9.86334 12.8397C9.57045 12.5468 9.09557 12.5468 8.80268 12.8397C8.50978 13.1326 8.50978 13.6075 8.80268 13.9003L10.8027 15.9003C11.0955 16.1932 11.5704 16.1932 11.8633 15.9004L15.1973 12.5674Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 4.25012C9.19057 4.25012 6.79026 5.96736 5.77366 8.40439C3.1937 8.96622 1.25 11.2424 1.25 14.0001C1.25 17.1753 3.82479 19.7501 7 19.7501H18C20.6232 19.7501 22.75 17.6233 22.75 15.0001C22.75 12.6198 20.9988 10.6482 18.7145 10.3035C18.3659 6.90266 15.493 4.25012 12 4.25012ZM7.034 9.30979C7.73911 7.23826 9.69501 5.75012 12 5.75012C14.8998 5.75012 17.25 8.10034 17.25 11.0001C17.25 11.4143 17.5858 11.7501 18 11.7501C19.7948 11.7501 21.25 13.2053 21.25 15.0001C21.25 16.7949 19.7948 18.2501 18 18.2501H7C4.65321 18.2501 2.75 16.3469 2.75 14.0001C2.75 11.8556 4.3475 10.0949 6.42546 9.81123C6.70689 9.7728 6.94247 9.57869 7.034 9.30979Z"
    }, null, -1)
  ])))
}
export default { render: render }